import React from "react";
import _ from "lodash";
import Select from "react-select";
// import AsyncSelect from "react-select/async";

import { NetworkAPI } from "apis";

let cache = {};

class CustomTargetingKeysSelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      options: [],
      selectedValue: null,

      isLoading: false,
      errMsg: null,
    };

    this.asyncFn = null;

    this.handleChange = this.handleChange.bind(this);
  }

  async componentDidMount() {
    const { networkId, customTargetingKeys } = this.props;
    if (!networkId) {
      return;
    }

    if (customTargetingKeys) {
      cache[networkId] = customTargetingKeys;
    }

    this.asyncFn = await this.queryCustomTargetingKeys();
  }

  async queryCustomTargetingKeys() {
    const { networkId } = this.props;

    this.setState({ isLoading: true });
    try {
      let items = [];
      if (cache[networkId]) {
        items = cache[networkId];
      } else {
        const r = await NetworkAPI.getCustomTargetingKeys({ networkId });
        items = r.items;
        cache[networkId] = items;
      }
      const options = this.parseOption(items);

      this.setState({
        options,
        errMsg: null,
        isLoading: false,
      });
    } catch (err) {
      console.log(err);
      this.setState({
        errMsg: `Error query custom targeting keys: ${err.toString()}`,
        isLoading: false,
      });
    }
  }

  parseOption(items) {
    const { keyId, removeReportableOffOption } = this.props;

    let options = _.map(items, (r) => {
      return {
        value: r.id,
        id: r.id,
        name: r.name,
        reportableType: r.reportableType,
        label: `${r.id} - ${r.name} (Reportable Type: ${r.reportableType})`,
      };
    });

    if (removeReportableOffOption) {
      options = _.filter(options, (o) => {
        return o.reportableType !== "OFF";
      });
    }

    if (keyId) {
      let selectedValue = undefined;

      if (keyId) {
        selectedValue = _.find(options, (o) => {
          return o.id === _.parseInt(keyId); // keyId could be string
        });
      }

      this.setState({
        selectedValue,
        isLoading: false,
      });

      if (this.props.handleOnChange) {
        this.props.handleOnChange(selectedValue);
      }
    }

    return options;
  }

  handleChange(option) {
    this.setState({
      selectedValue: option,
    });
    this.props.handleOnChange(option);

    // if (this.props.isMulti) {
    //   const ids = _.map(option, (o) => {
    //     return o.value;
    //   });
    //   this.props.handleOnChange(ids);
    // } else {
    //   const valueKey = this.props.valueKey || "networkId";
    //   const item = _.find(this.state.items, { [valueKey]: option.value });
    //   this.props.handleOnChange(item);
    // }
  }

  componentWillUnmount() {
    if (this.asyncFn) {
      this.asyncFn.cancel();
    }
  }

  // async loadOptions(inputValue, callback) {
  //   const { networkId } = this.props;
  //   const { keys } = await NetworkAPI.getCustomTargetingKeys({
  //     networkId: 356,
  //   });
  //   console.log(keys);
  //   let options = _.map(keys, (r) => {
  //     return {
  //       value: r.id,
  //       label: `${r.id} - ${r.name} (${r.type})`,
  //     };
  //   });
  //   return options;
  // }

  render() {
    const { options, selectedValue, errMsg, isLoading } = this.state;

    if (errMsg) {
      return <div className="bg-red-100 px-2 py-1 text-red-800">{errMsg}</div>;
    }

    return (
      <>
        {/* Use this if query by input */}
        {/* <AsyncSelect
          cacheOptions={true}
          loadOptions={this.loadOptions}
          defaultOptions
        ></AsyncSelect> */}
        <Select
          value={selectedValue}
          onChange={this.handleChange}
          options={options}
          isMulti={this.props.isMulti}
          isClearable
          isLoading={isLoading}
          isDisabled={this.props.isReadonly}
        />
      </>
    );
  }
}

export default CustomTargetingKeysSelector;
